import { z } from "zod/v4";

import { RechargeGlobalSettingsDtoSchema } from "../../../../dtos/recharge-integrations";

export const PatchRechargeRequestBodySchema = z.object({
  recharge: RechargeGlobalSettingsDtoSchema.extend({
    enabled: z.boolean(),
    id: z.uuid(),
  }),
});
export type PatchRechargeRequestBodyType = z.infer<
  typeof PatchRechargeRequestBodySchema
>;
